import {
  BusinessDays_TOKYO_NAGOYA_OSAKA,
  BusinessDays_FUKUOKA_SAPPORO
} from './business-days'
import { DaysOfWeek } from './date-util'

export default class ClinicConstantsWomenLocal {
  /* clinic情報 */
  static SAPPORO = {
    medicalBusinessId: '3e87ca22-65fd-4679-8756-67a0381126a7',
    name: '札幌',
    clinicId: 'c299d13a2cc84faf9a60a9fb542fc9b5', // (テストクリニック 新宿)
    clinicalDepartmentId: '467e4aadbea1438496c310bc7a2ca878', // (test科目(コース持ち))
    treatmentCourseId: '9018d292c3e44b1b9b8280b910b4b122', // テストコース1
    businessDays: BusinessDays_FUKUOKA_SAPPORO,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static TOKYO = {
    medicalBusinessId: '3e87ca22-65fd-4679-8756-67a0381126a7',
    name: '東京',
    clinicId: '98111143b0ee4c3a809fe1583edee03f', // (オンラインクリニック丸の内院)
    clinicalDepartmentId: '368658061bb141fe96c2016ba7aeab0b', // (発毛(コース))
    treatmentCourseId: '03104c8e0ad44dd58daf86596efa2743', // (テストデフォルトコース)
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: { [DaysOfWeek.WED]: { am: true, pm: false } }
  }

  static NAGOYA = {
    medicalBusinessId: '3e87ca22-65fd-4679-8756-67a0381126a7',
    name: '名古屋',
    clinicId: '29565962a427415d8e3e95f1f50ddc86', // (オンラインクリニック新宿院)
    clinicalDepartmentId: '43514185dd7a4a36bfa1fdfb47cd3830', // (ナルコレプシー外来)
    treatmentCourseId: '',
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: {
      [DaysOfWeek.WED]: { am: true, pm: false }
    }
  }

  static OSAKA = {
    medicalBusinessId: '3e87ca22-65fd-4679-8756-67a0381126a7',
    name: '大阪',
    clinicId: 'c299d13a2cc84faf9a60a9fb542fc9b5', // (テストクリニック 新宿)
    clinicalDepartmentId: '467e4aadbea1438496c310bc7a2ca878', // (test科目(コース持ち))
    treatmentCourseId: '12335b5a5ee4482092eec8ddc7647812', // テストコース2
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: { [DaysOfWeek.WED]: { am: true, pm: false } }
  }

  static FUKUOKA = {
    medicalBusinessId: '3e87ca22-65fd-4679-8756-67a0381126a7',
    name: '福岡',
    clinicId: '29565962a427415d8e3e95f1f50ddc86', // (オンラインクリニック新宿院)
    clinicalDepartmentId: '43514185dd7a4a36bfa1fdfb47cd3830', // (ナルコレプシー外来)
    treatmentCourseId: '',
    businessDays: BusinessDays_FUKUOKA_SAPPORO,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static CLINICS = [
    ClinicConstantsWomenLocal.SAPPORO,
    ClinicConstantsWomenLocal.TOKYO,
    ClinicConstantsWomenLocal.NAGOYA,
    ClinicConstantsWomenLocal.OSAKA,
    ClinicConstantsWomenLocal.FUKUOKA
  ]
}
